export async function checkAuthorHomepageForClose(bucketIdsThatWillClose, getState, kickSubscription) {
    await kickSubscription("AUTHOR_HOMEPAGE");
    if (bucketIdsThatWillClose.size === 0) {
        return true;
    }

    // kicking subscription until open ideas does not have the bucketIds that will close
    const {authorDetails} = getState();

    const hasExpectedBucketIdsClosed = idea => {
        const {portfolioDetails} = idea;
        return !portfolioDetails.find(details => bucketIdsThatWillClose.has(details.bucketId) && details.open);
    };
    return authorDetails.content.openIdeas.every(hasExpectedBucketIdsClosed);
}